exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-header[data-v-84bc4b76]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-84bc4b76&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Banet/errorsAndNotifications/BanetModalInfo.vue
// module id = 601
// module chunks = 0